<template>
  <px-custom-dialog v-model="dialog"
                    content-class="rounded-card"
                    width="1000">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
        <v-btn icon
               v-on="on">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </slot>
    </template>
    <template v-slot:title>
      Gerar solicitação parcial
    </template>
    <template>
      <div v-if="loading">
        <px-circular-loading/>
      </div>
      <div v-if="!loading && produtos.length" class="mt-3">
        <span>
          Selecione abaixo os produtos que deseja enviar para a solicitação:
        </span>
        <v-list>
          <v-list-item v-for="produto in produtos" :key="produto.id">
            <v-list-item-action>
              <v-checkbox v-model="produto.selecionado"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                <span v-if="hasCodigo(produto)">({{ produto.produto.codigo }})</span>
                {{ descricaoProduto(produto) }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ produto.quantidade }} {{ produto.unidadeMedida.descricao }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

      </div>
      <div v-if="!loading && !produtos.length" class="mt-3">
        Esta aprovação não possui nenhum produto aprovado.
      </div>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small elevation-0"
             :loading="loadingSave"
             :disabled="!hasProdutosSelecionados"
             @click="save">
        Criar solicitação
      </v-btn>
      <v-btn text class="normal-btn-text" @click="close">
        Cancelar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>


<script>
import { SituacaoAprovacao } from 'px-business-components';
import AprovacaoSolicitacaoService
  from '@/modules/aprovacao-solicitacao/aprovacao-solicitacao-service';

export default {
  props: {
    aprovacaoId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      loadingSave: false,
      aprovacao: null,
      produtos: [],
    };
  },
  computed: {
    hasProdutosSelecionados() {
      return this.produtos.some(produto => produto.selecionado);
    },
    hasCodigo() {
      return produto => (produto.produto ? produto.produto.codigo : false);
    },
    descricaoProduto() {
      return produto => (produto.produto
        ? produto.produto.descricao : produto.especificacaoProduto);
    },
  },
  methods: {
    buildProdutosAprovados() {
      this.produtos = this.aprovacao.produtos.filter(produto => produto.situacao
        === SituacaoAprovacao.keys.APROVADO.key && !produto.requisicaoProduto)
        .map(produto => ({
          ...produto,
          selecionado: true,
        }));
    },
    getAprovacao() {
      this.loading = true;
      AprovacaoSolicitacaoService.get(this.aprovacaoId)
        .then(({ data }) => {
          this.aprovacao = data;
          this.buildProdutosAprovados();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    save() {
      this.loadingSave = true;
      const payload = this.produtos.filter(produto => produto.selecionado)
        .map(produto => ({
          id: produto.id,
        }));
      AprovacaoSolicitacaoService.gerarSolicitacaoProdutos(this.aprovacao.id, payload)
        .then(({ data }) => {
          this.close();
          this.$router.push({
            name: 'main.requiscao.detalhes',
            params: {
              id: data.id,
            },
          });
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    close() {
      this.dialog = false;
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue) {
        this.getAprovacao();
      }
    },
  },
};
</script>
